import { Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { buildLink } from '../../../../../services/companyFilings/companyFilings.service';
import { CompanyFilingsDto } from '../../../../../services/dtos/companyFilings/companyFilings.dto';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import styles from './CompanyFilingsFileNameRenderer.module.scss';
import { trackDocumentDownload } from '../../../../../utils/trackUsageUtils';
import useFetchCompanyDocsTypes from '../../../../../hooks/documents/useFetchFilingsTypes';
import { getSubTabName } from '../../CompanyDocumentsTab.logic';

const cx = classNames.bind(styles);

const CompanyFilingsFileNameRenderer = ({
  data,
  row: { isDisabled, isHovered },
}: GroupedTableRowRendererProps<CompanyFilingsDto>): React.ReactElement => {
  const { data: types } = useFetchCompanyDocsTypes();

  const documentTypes = useMemo(
    () =>
      types?.reduce(
        (acc: Record<number, string>, item) => ({
          ...acc,
          [item.id]: item.name,
        }),
        {}
      ) || {},
    [types]
  );

  const documentDownloadHandler = (documentName: string, documentDate: string, documentType: string) => {
    trackDocumentDownload({
      tabName: getSubTabName(window.location.href),
      documentName,
      documentDate,
      documentType,
    });
  };

  return (
    <div className={cx('body', { 'gray-out': isHovered && isDisabled })}>
      <span>
        <Icon name={ICONS.Doc} />
      </span>
      <span>
        <a
          href={buildLink(data)}
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            documentDownloadHandler(
              data.uploadedFile.originalFilename,
              data.date.substring(0, 10),
              documentTypes[data.type.toString()]
            )
          }
        >
          {data.uploadedFile.originalFilename}
        </a>
      </span>
    </div>
  );
};

export default CompanyFilingsFileNameRenderer;
